import { useContext } from "react";
import { ThemeContext } from "../contexts/ThemeContext";

// Resolves the app theme to a Google Maps `colorScheme` value so maps match
// light/dark mode. Vector maps (those with a mapId) apply `colorScheme` at
// construction time only, so callers should also include the returned value in
// the <Map> `key` to force a remount when the user switches theme.
//
//   light  -> "LIGHT"
//   dark   -> "DARK"
//   system -> "FOLLOW_SYSTEM"  (Google follows the OS preference itself)
export function useMapColorScheme() {
  const themeCtx = useContext(ThemeContext);
  const theme = themeCtx?.theme;
  if (theme === "dark") return "DARK";
  if (theme === "light") return "LIGHT";
  return "FOLLOW_SYSTEM";
}
